import { Button, Container, SearchInput } from '@/components';
import React, { useCallback } from 'react';
import MinMaxTable from './MinMaxTable';
import { useMinMaxContext } from '@/context/minMaxContext/MinMaxContextProvider';
import { IoMdAdd } from 'react-icons/io';
import {
  ModalProvider,
  useModal,
} from '@/components/common/modal/ModalContext';
import CreateMinMaxSetting from './CreateMinMaxSetting';

const MinMaxView = () => {
  const { openModal, closeModal } = useModal();
  const {
    searchQuery,
    setSearchQuery,
    getAllMinMaxSettingsAPI,
    clearFormData,
    setCurrentPage,
  } = useMinMaxContext(); //gives access to min-max context

  const handleOpenModal = useCallback(() => {
    //clear the form and create a new min-max setting
    clearFormData();
    openModal(
      <CreateMinMaxSetting closeModal={closeModal} />,
      'Create MinMax Setting',
    );
  }, [clearFormData, closeModal, openModal]);

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
  };

  const onSearchClick = () => {
    setCurrentPage('0');
    getAllMinMaxSettingsAPI();
  };

  return (
    <Container title="Min Max Setting">
      <div className="lg:flex justify-end mx-5 lg:gap-5 gap-2 mt-3 ">
        <SearchInput
          value={searchQuery}
          onChange={handleSearch}
          onSearchClick={onSearchClick}
        />
        <div className="lg:mt-0 flex justify-center mt-2">
          <Button onClick={handleOpenModal}>
            <div>Add New Min-Max Setting</div>
            <div>
              <IoMdAdd />
            </div>
          </Button>
        </div>
      </div>
      <MinMaxTable />
    </Container>
  );
};

const App = () => (
  <ModalProvider>
    <MinMaxView />
  </ModalProvider>
);

//export default MinMaxView;
export default App;
